import DateFnsUtils from "@date-io/date-fns/build";
import { Button, Checkbox, FormControlLabel, Grid, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TableSortLabel } from "@material-ui/core";
import { CheckCircleOutline } from "@material-ui/icons";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from "moment/moment";
import React, { useState } from "react";
import NumberFormat from "react-number-format";
import { trackPromise } from "react-promise-tracker";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import PaginatedTableActions from "src/components/Table/PaginatedTableActions";
import { INTERNAL_BILATERAL_SCHEDULE_RESULTS_DIRECTION, INTERNAL_BILATERAL_SCHEDULE_RESULTS_ORDER_BY, INTERNAL_BILATERAL_SCHEDULE_RESULTS_PAGE_SIZE, INTERNAL_BILATERAL_SCHEDULE_RESULTS_RETRIEVED, INTERNAL_BILATERAL_SEARCH_END_DATE, INTERNAL_BILATERAL_SEARCH_ISCONFIMRED, INTERNAL_BILATERAL_SEARCH_START_DATE } from "src/store/InternalBilateral/InternalBilateralActionTypes";
import { onError } from "src/store/actions/popupActions";
import useStyles from "../../../Styles";
import axios from "../../../axios/AxiosInterceptors";

const SchedulesTable = (props) => {

    const classes = useStyles();
    const params = useParams();
    const dispatch = useDispatch();
    const results = useSelector(state => state.internalBilateral.scheduleResults);
    const pageSize = useSelector(state => state.internalBilateral.scheduleResultsPageSize);
    const direction = useSelector(state => state.internalBilateral.scheduleResultsDirection);
    const orderBy = useSelector(state => state.internalBilateral.scheduleResultsOrderBy);
    const startDate = useSelector(state => state.internalBilateral.scheduleSearchStartDate);
    const endDate = useSelector(state => state.internalBilateral.scheduleSearchEndDate);
    const selectedContract = useSelector(state => state.internalBilateral.selectedContract);
    const isConfirmed = useSelector(state => state.internalBilateral.isConfirmed);
    const [checkedSchedules, setCheckedSchedules] = useState([]);
    const [selectAllChecked, setSelectAllChecked] = useState(false);

    const retrieveSchedules = async (pageNumber, pageSize, orderBy, direction) => {
        let urlParams = { pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, direction: direction };
        urlParams['startDate'] = moment(startDate).format("YYYY-MM-DD");
        urlParams['endDate'] = moment(endDate).format("YYYY-MM-DD");
        urlParams['isConfirmed'] = isConfirmed;
        setSelectAllChecked(false);
        await trackPromise(axios.get("/inschedule/v3/account/" + params.accountId + "/inschedule/contract/" + params.contractId + "/schedule",
            { params: urlParams }).then(response => {
                dispatch({ type: INTERNAL_BILATERAL_SCHEDULE_RESULTS_RETRIEVED, scheduleResults: response.data });
            }).catch(error => {
                dispatch(onError(error.response));
            }));
    }

    const confirmSchedule = async (schedules) => {
        await trackPromise(axios.put("/inschedule/v3/account/" + params.accountId + "/inschedule/contract/" + params.contractId + "/schedule", JSON.stringify(schedules)).then(response => {
            dispatch({ type: INTERNAL_BILATERAL_SCHEDULE_RESULTS_RETRIEVED, scheduleResults: response.data });
        }).catch(error => {
            dispatch(onError(error.response))
        }));
    }

    const handleSort = (column) => {
        let sortDirection = column === orderBy && direction === 'asc' ? 'desc' : 'asc'
        dispatch({ type: INTERNAL_BILATERAL_SCHEDULE_RESULTS_DIRECTION, scheduleResultsDirection: sortDirection });
        dispatch({ type: INTERNAL_BILATERAL_SCHEDULE_RESULTS_ORDER_BY, scheduleResultsOrderBy: column });
        retrieveSchedules(0, pageSize, column, sortDirection);
    }

    const handlePageChange = (pageNumber, pageSize) => {
        retrieveSchedules(pageNumber, pageSize, orderBy, direction);
    }

    const calculateRowsPerPage = (rowsPerPage) => {
        if (!rowsPerPage) {
            return 10;
        }
        if (rowsPerPage <= 10) {
            return 10;
        }
        if (rowsPerPage <= 25) {
            return 25;
        }
        if (rowsPerPage <= 50) {
            return 50;
        }
        if (rowsPerPage <= 744) {
            return 745;
        }
        return rowsPerPage;
    }

    const handleRowsPerPageChange = (e) => {
        dispatch({ type: INTERNAL_BILATERAL_SCHEDULE_RESULTS_PAGE_SIZE, scheduleResultsPageSize: e.target.value });
        retrieveSchedules(0, e.target.value, orderBy, direction);
    }

    const startDateChangeHandler = (date) => {
        dispatch({ type: INTERNAL_BILATERAL_SEARCH_START_DATE, scheduleSearchStartDate: date });
    }

    const endDateChangeHandler = (date) => {
        dispatch({ type: INTERNAL_BILATERAL_SEARCH_END_DATE, scheduleSearchEndDate: date });
    }

    const isConfirmedChangeHandler = () => {
        dispatch({ type: INTERNAL_BILATERAL_SEARCH_ISCONFIMRED });
    }

    const doSearch = () => {
        setCheckedSchedules([]);
        retrieveSchedules(0, pageSize, orderBy, direction);
    }

    const confirmIndividualSchedule = (schedule) => {
        confirmSchedule([schedule]);
    }

    const confirmSelectedSchedules = () => {
        confirmSchedule(checkedSchedules);
    }

    const isScheduleChecked = (id) => {
        return checkedSchedules.find(r => r.id === id) !== undefined;
    }

    const handleScheduleChecked = (schedule) => {
        let index = -1;
        for (let i = 0; i < checkedSchedules.length; i++) {
            if (checkedSchedules[i].id === schedule.id) {
                index = i;
            }
        }
        if (index === -1) {
            checkedSchedules.push(schedule);
        } else {
            checkedSchedules.splice(index, 1);
            setSelectAllChecked(false);
        }
        setCheckedSchedules([...checkedSchedules]);
    }

    const handleSelectAllChecked = () => {
        if (!selectAllChecked && results && results.results && results.results.length > 0) {
            checkedSchedules.push(...results.results);
            setCheckedSchedules([...checkedSchedules]);
            setSelectAllChecked(true);
        } else if (selectAllChecked) {
            setCheckedSchedules([]);
            setSelectAllChecked(false);
        }
    }

    return (
        <React.Fragment>
            <Grid container spacing={2} style={{ height: "100%" }} alignItems="center">
                <Grid item xs={6} sm={1} />
                <Grid item xs={6} sm={2}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker disableToolbar variant="inline" format="yyyy-MM-dd" label="Start Date" name="startDate"
                            onChange={(date) => startDateChangeHandler(date)} value={startDate} fullWidth
                            autoOk={true} maxDate={endDate ? endDate : null} />
                    </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={6} sm={1} />
                <Grid item xs={6} sm={2}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker disableToolbar variant="inline" format="yyyy-MM-dd" label="End Date" name="endDate"
                            onChange={(date) => endDateChangeHandler(date)} value={endDate} fullWidth
                            autoOk={true} minDate={startDate ? startDate : null} />
                    </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={6} sm={1} />
                <Grid item xs={6} sm={2}>
                    <FormControlLabel control={<Checkbox checked={isConfirmed} onChange={isConfirmedChangeHandler} />} label="Confirmed" />
                </Grid>
                <Grid item xs={6} sm={3}>
                    <Button onClick={doSearch}>Search</Button>
                </Grid>
            </Grid>
            <TableContainer className={classes.tableContainer}>
                <Table className={classes.table} size="small" stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                <FormControlLabel control={<Checkbox checked={selectAllChecked}
                                    onChange={() => handleSelectAllChecked()} />} />
                            </TableCell>
                            <TableCell>
                                <TableSortLabel active={orderBy === "hourBeginningDate"} direction={orderBy === "hourBeginningDate" ? direction : 'asc'}
                                    onClick={() => handleSort("hourBeginningDate")}>
                                    Hour Beginning Date
                                    {orderBy === "hourBeginningDate" ? (<span className={classes.visuallyHidden}>{direction === "desc" ? 'sorted descending' : 'sorted ascending'}</span>) : null}
                                </TableSortLabel>
                            </TableCell>
                            <TableCell>
                                <TableSortLabel active={orderBy === "hourEndingDate"} direction={orderBy === "hourEndingDate" ? direction : 'asc'}
                                    onClick={() => handleSort("hourEndingDate")}>
                                    Hour Ending Date
                                    {orderBy === "hourEndingDate" ? (<span className={classes.visuallyHidden}>{direction === "desc" ? 'sorted descending' : 'sorted ascending'}</span>) : null}
                                </TableSortLabel>
                            </TableCell>
                            <TableCell>
                                <TableSortLabel active={orderBy === "hourBeginning"} direction={orderBy === "hourBeginning" ? direction : 'asc'}
                                    onClick={() => handleSort("hourBeginning")}>
                                    Hour Beginning
                                    {orderBy === "hourBeginning" ? (<span className={classes.visuallyHidden}>{direction === "desc" ? 'sorted descending' : 'sorted ascending'}</span>) : null}
                                </TableSortLabel>
                            </TableCell>
                            <TableCell>
                                <TableSortLabel active={orderBy === "hourEnding"} direction={orderBy === "hourEnding" ? direction : 'asc'}
                                    onClick={() => handleSort("hourEnding")}>
                                    Hour Ending
                                    {orderBy === "hourEnding" ? (<span className={classes.visuallyHidden}>{direction === "desc" ? 'sorted descending' : 'sorted ascending'}</span>) : null}
                                </TableSortLabel>
                            </TableCell>
                            <TableCell>
                                <TableSortLabel active={orderBy === "segmentValue"} direction={orderBy === "segmentValue" ? direction : 'asc'}
                                    onClick={() => handleSort("segmentValue")}>
                                    MWhs
                                    {orderBy === "segmentValue" ? (<span className={classes.visuallyHidden}>{direction === "desc" ? 'sorted descending' : 'sorted ascending'}</span>) : null}
                                </TableSortLabel>
                            </TableCell>
                            <TableCell>
                                <TableSortLabel active={orderBy === "sellerStatus"} direction={orderBy === "sellerStatus" ? direction : 'asc'}
                                    onClick={() => handleSort("sellerStatus")}>
                                    Seller Status
                                    {orderBy === "sellerStatus" ? (<span className={classes.visuallyHidden}>{direction === "desc" ? 'sorted descending' : 'sorted ascending'}</span>) : null}
                                </TableSortLabel>
                            </TableCell>
                            <TableCell>
                                <TableSortLabel active={orderBy === "buyerStatus"} direction={orderBy === "buyerStatus" ? direction : 'asc'}
                                    onClick={() => handleSort("buyerStatus")}>
                                    Buyer Status
                                    {orderBy === "buyerStatus" ? (<span className={classes.visuallyHidden}>{direction === "desc" ? 'sorted descending' : 'sorted ascending'}</span>) : null}
                                </TableSortLabel>
                            </TableCell>
                            <TableCell>
                                <TableSortLabel active={orderBy === "confirmed"} direction={orderBy === "confirmed" ? direction : 'asc'}
                                    onClick={() => handleSort("confirmed")}>
                                    Confirmed
                                    {orderBy === "confirmed" ? (<span className={classes.visuallyHidden}>{direction === "desc" ? 'sorted descending' : 'sorted ascending'}</span>) : null}
                                </TableSortLabel>
                            </TableCell>
                            <TableCell>
                                Actions
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {results && results.results && results.results.length > 0 && results.results.map(r => {
                            return (
                                <TableRow key={r.id}>
                                    <TableCell><FormControlLabel control={<Checkbox checked={isScheduleChecked(r.id)}
                                        onChange={(schedule) => handleScheduleChecked(r)} />} />
                                    </TableCell>
                                    <TableCell>{r.hourBeginningDateTime.hourBeginningDate}</TableCell>
                                    <TableCell>{r.hourEndingDateTime.hourEndingDate}</TableCell>
                                    <TableCell>{r.hourBeginningDateTime.hourBeginning}</TableCell>
                                    <TableCell>{r.hourEndingDateTime.hourEnding}</TableCell>
                                    <TableCell>{<NumberFormat value={r.segmentValue} displayType='text' fixedDecimalScale={true} decimalScale={3} thousandSeparator />}</TableCell>
                                    <TableCell>{r.sellerStatus}</TableCell>
                                    <TableCell>{r.buyerStatus}</TableCell>
                                    <TableCell>{r.confirmed ? <CheckCircleOutline /> : ''}</TableCell>
                                    <TableCell>{!r.confirmed ? <Button onClick={(schedule) => confirmIndividualSchedule(r)} startIcon={<CheckCircleOutline />}></Button> : ''}</TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                    <TableFooter>
                        <TableRow>
                            <TablePagination count={results.totalCount ? results.totalCount : 0} onPageChange={handlePageChange}
                                page={results.pageNumber ? results.pageNumber : 0}
                                rowsPerPage={calculateRowsPerPage(results.pageSize)} onRowsPerPageChange={handleRowsPerPageChange}
                                rowsPerPageOptions={[10, 25, 50, 745]} colSpan={10} ActionsComponent={PaginatedTableActions} />
                        </TableRow>
                    </TableFooter>
                </Table>
            </TableContainer>
            <Grid container spacing={2}>
                <Grid item xs={6} sm={4} />
                <Grid item xs={6} sm={4}>
                    <Button onClick={confirmSelectedSchedules}>Confirm Selected Schedules</Button>
                </Grid>
                <Grid item xs={6} sm={4} />
            </Grid>
        </React.Fragment >
    )

}

export default SchedulesTable;